export default "__VITE_ASSET__CyQhFMXo__"